module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-2-50.fd29fdc2.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-2-50.png
// module id = 2554
// module chunks = 11